import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	discoveredIconLabel: {
		id: 'servicedesk-settings-virtual-agent-create-intent-templates-sidebar.common.template-icon.discovered-icon-label',
		defaultMessage: 'This template is from your data.',
		description:
			'Label text used for the icon for templates which were generated using the customers data.',
	},
	standardIconLabel: {
		id: 'servicedesk-settings-virtual-agent-create-intent-templates-sidebar.common.template-icon.standard-icon-label',
		defaultMessage: 'This template was created from the most commonly used intents.',
		description:
			'Label text used for the icon for templates which were created based on the most commonly used intents.',
	},
});
